








import {Component, Prop} from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import JobWorkerInterviewDto from '@/models/JobWorkerInterviews/JobWorkerInterviewDto';

@Component({
  name: 'JobWorkerInterviewContactConfirmationStatus',
})
export default class extends GiganautVue {

	@Prop({required: true})
	interview: JobWorkerInterviewDto;

	get pendingConfirmation() {
		return (!this.interview.contactConfirmedById && !this.interview.contactDeclinedById);
	}

	get confirmed() {
		if (this.interview.contactConfirmedById) {
			return true;
		}
		return false
	}

	get declined() {
		if (this.interview.contactDeclinedById) {
			return true;
		}
		return false
	}
}
